import PropTypes from 'prop-types'

const localePropTypes = {
  defaultLangKey: PropTypes.string,
  langs: PropTypes.arrayOf(PropTypes.string)
}

export default localePropTypes
